import { toast } from 'react-toastify';

import { updatePictureCollection } from '@/services/collection';
import { convertUrlToFile } from '@/utils';

const useSetThumbnail = () => {
  const handleSetAsThumbnail = async (fileUrl: string, fileName: string, collectionId: number) => {
    try {
      const fileConverted = await convertUrlToFile(fileUrl, fileName);
      const formData = new FormData();
      formData.append('picture', fileConverted, 'thumbnail');
      await updatePictureCollection(collectionId, formData);
      toast.success('Update collection successfully!');
    } catch (error: any) {
      toast.error(error?.message);
    }
  };

  return { handleSetAsThumbnail };
};

export default useSetThumbnail;
